import { create } from 'zustand'
import type { User, UserStore } from '../types'

export const useUserStore = create<UserStore>((set) => ({
    user: null,
    isLoading: true,
    setUser: (user: Nullable<User>) => set({ user }),
    setIsLoading: (isLoading: boolean) => set({ isLoading })
}))
